let reservations_array = '';
async function renderReservations() {

    clearAllIntervals();
    let reservations = await getReservations();
    reservations_array = reservations.reservations;
    console.log(reservations);
    if (reservations.has_reservations && reservations_array.length > 0) {
        $('#reservation_alert').remove();


        $('body').append(`
<div id="reservation_alert" class="fixed bottom-0 left-1/2 transform -translate-x-1/2 bg-gray-50 dark:bg-gray-700 border rounded border-gray-200 dark:border-gray-500 p-2 z-[200] text-gray-800 dark:text-gray-100 w-[207px] h-[132px] shadow-lg transition-all duration-500 ease-in-out scrollbar-thin scrollbar-thumb-green-500 scrollbar-track-green-50">
    <div class="grids relative max-h-screen">
        <div class="overflow-auto mb-16">
            <a href="/reservations/confirm">
            <button id="show_confirm_dialogs" class="btn btn-success mb-4 text-2xl !px-0">
                Click To Confirm
                <div id="countdown" class="text-xl font-bold text-gray-200 w-fit mx-auto mt-2 px-4">
                    Loading countdown...
                </div>
            </button>
            </a>
        </div>
        <div class="sticky bottom-0 flex justify-between">
        <button id="close_confirm_dialog" class="btn btn-danger p-1" style="display: none;"><i class="fa fa-times"></i></button>
        <a href="/reservations/confirm" id="confirm_reservations" class="btn btn-success p-1" style="display: none;">Confirm</a>
        </div>
    </div>
</div>
        `);

        renderCountDownTimer();
    } else {
        $('#reservation_alert').remove();
        clearAllIntervals();
    }
}

function renderCountDownTimer() {
    console.log("reservations_array")
    console.log(reservations_array)
    // Find the oldest reserved_at timestamp
    const oldestReservation = reservations_array.reduce((oldest, current) => {
        return new Date(current.reserved_at) < new Date(oldest.reserved_at) ? current : oldest;
    });
    console.log(oldestReservation.reserved_at);
    // Add 15 minutes to the oldest timestamp
    const targetTime = new Date(oldestReservation.reserved_at);
    targetTime.setMinutes(targetTime.getMinutes() + 15);


    // Countdown function
    async function updateCountdown() {
        const now = new Date();
        const timeDifference = targetTime - now;

        if (timeDifference <= 0) {
            clearInterval(countdownInterval);
            $('#countdown').text('⏰ Countdown Finished!');
            $('#countdown').html('<div id="hourglass" class="inline-block text-xs !leading-3">⏰</div> <span class="text-xs">Oh no, time’s up! But don’t worry, you can always try again. 🌸</span>');
            const runClearExpiredReservations = async () => {
                try {
                    const response = await fetch(`/api/runClearExpiredReservations`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        },
                        body: JSON.stringify({
                            json: true,
                        }),
                    });
                    return await response.json();
                } catch (error) {
                    console.log(error);
                    return { has_reservations: false, reservations: [] };
                }
            };
            await runClearExpiredReservations();
            $('#confirm_reservations').hide();
            setTimeout(function() {
                window.location.reload();
            }, 5000);
            return;
        }

        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        $('#countdown').html(`<div id="hourglass" class="inline-block">⏳</div> ${minutes}m ${seconds}s remaining`);
    }

    // Hourglass Animation using Tailwind classes
    function animateHourglass() {
        $('#hourglass')
            .addClass('animate-spin-slow bounce') // Tailwind animation classes
            .one('animationend', function () {
                $(this).removeClass('animate-spin-slow bounce'); // Reset for the next animation
            });
    }

    // Start the countdown
    updateCountdown(); // Display immediately
    const countdownInterval = setInterval(updateCountdown, 1000);

    // Trigger the hourglass animation every 5 seconds
    setInterval(animateHourglass, 5000);
}
function clearAllIntervals() {
    let highestId = setInterval(() => {}, 1000);
    clearInterval(highestId);
    for (let i = 0; i <= highestId; i++) {
        clearInterval(i);
    }
}

// Attach to the global scope
window.renderReservations = renderReservations;

$(document).ready(async function () {
    await renderReservations();
});

const getReservations = async () => {
    try {
        const response = await fetch(`/api/reservations/user`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            body: JSON.stringify({
                json: true,
            }),
        });
        return await response.json();
    } catch (error) {
        console.log(error);
        return { has_reservations: false, reservations: [] };
    }
};

$(document).on("click", "#show_confirm_dialog", function () {
    $(this).hide();
    $('#close_confirm_dialog').show();
    $('#confirm_reservations').show();
    const alertBox = $("#reservation_alert");

    // Apply new classes for center alignment
    alertBox
        .removeClass("bottom-0 -translate-x-1/2")
        .addClass("inset-0 ml-auto w-[90%] overflow-auto");

    // Adjust height and width for centered content
    alertBox.css({
        "max-width": "200px",
        height: "300px",
    });
});

$(document).on("click", "#close_confirm_dialog", function () {
    $('#close_confirm_dialog').hide();
    $('#confirm_reservations').hide();
    const alertBox = $("#reservation_alert").hide();

    // alertBox.fadeOut();
    // Revert to initial position and size
    alertBox
        .removeClass("inset-0 ml-auto w-[90%] overflow-auto");

    // Reset width and height
    alertBox.css({
        "max-width": "",
        height: "",
    });
    setTimeout(function () {
        alertBox
            .addClass("bottom-0 -translate-x-1/2").slideDown();
    }, 200)
    $('#show_confirm_dialog').show();
});
